import { BrowserCompatibility } from 'browser-compatibility';
import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class BrowserCompatibilityGuard {
  private router: Router = inject(Router);

  /* eslint-disable @typescript-eslint/no-unused-vars */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const compatible = BrowserCompatibility.isCompatible();
    if (!compatible) {
      this.router.navigate(['/browsernotsupported']);
    }
    return compatible;
  }
}
